module.exports = __webpack_public_path__ + "img/more.070b73d9.svg";